import { ThemeToggle } from "@/components/ThemeToggle";
import { useMemo, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { LogOut } from "@/lib/icons";
import { AccountSwitcher } from "@/components/header/AccountSwitcher";

const linkCls = "text-xs sm:text-sm font-medium text-stone-700 hover:text-amber-800 px-1.5 sm:px-2 py-1";

export const NAV_ITEMS = [
  { to: "/client", label: "My habits", testid: "nav-client", roles: ["client"] },
  { to: "/journal", label: "Journal", testid: "nav-journal", roles: ["client"] },
  { to: "/community", label: "Community", testid: "nav-community", roles: ["client"] },
  { to: "/people", label: "My people", testid: "nav-people", roles: ["client", "clinician"] },
  { to: "/clinician", label: "People I support", testid: "nav-clinician", roles: ["clinician"] },
  { to: "/learn", label: "Learn", testid: "nav-learn", roles: ["client", "clinician"] },
  { to: "/billing", label: "Billing", testid: "nav-billing", roles: ["client", "clinician"] },
  { to: "/security", label: "Privacy", testid: "nav-security", roles: ["client", "clinician"] },
];

function UnreadNotes({ user }) {
  const [n, setN] = useState(0);
  const loc = useLocation();
  useEffect(() => {
    if (user?.role !== "client" || user?.is_demo) return;
    api.get("/community-inbox/unread").then((r) => setN(r.data.count)).catch(() => {});
  }, [user, loc.pathname]);
  if (!n) return null;
  return <span data-testid="nav-community-unread" title={`${n} unread note${n === 1 ? "" : "s"} waiting for you`} className="ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-white text-[10px] font-bold align-middle">{n}</span>;
}

export function NavLinks({ user }) {
  const items = useMemo(() => NAV_ITEMS.filter((n) => n.roles.includes(user.role) || (n.to === "/clinician" && user.is_coach)), [user.role, user.is_coach]);
  return (
    <>
      {items.map((n) => (
        <Link key={n.to} to={n.to} data-testid={n.testid} className={linkCls}>{n.label}{n.to === "/community" && <UnreadNotes user={user} />}</Link>
      ))}
      {user.is_admin && (
        <Link to="/admin/beta" data-testid="nav-beta-board" className="text-xs sm:text-sm font-semibold text-emerald-800 hover:text-emerald-900 px-1.5 sm:px-2 py-1">Beta board</Link>
      )}
    </>
  );
}

export function UserMenu({ user, onLogout }) {
  return (
    <>
      <ThemeToggle />
      <AccountSwitcher user={user} />
      <button onClick={onLogout} data-testid="logout-btn"
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium text-stone-700 hover:bg-stone-900 hover:text-white transition-colors">
        <LogOut className="w-4 h-4" />
        <span>Sign out</span>
      </button>
    </>
  );
}

export function GuestLinks() {
  return (
    <>
      <Link to="/login" data-testid="header-login-link" className="text-sm font-medium text-stone-700 hover:text-amber-800 px-3 py-2">Log in</Link>
      <Link to="/register" data-testid="header-register-link" className="amber-btn text-sm">Get started</Link>
    </>
  );
}
